<template>
  <div v-if="canUse" class="view-as-admin-select" :class="{compact}">
    <v-select
      v-model="selectedKey"
      :items="selectItems"
      :label="compact ? 'View as' : 'View as (preview)'"
      :dense="compact"
      :hide-details="compact"
      :outlined="!compact"
      item-text="text"
      item-value="value"
      class="view-as-select"
      :class="{'view-as-select--compact': compact}"
      :dark="dark"
      :color="dark ? 'white' : 'primary'"
      @change="onSelectChange"
    />
    <p
      v-if="!compact && viewAsActive"
      class="caption grey--text text--darken-1 mb-0 mt-2"
    >
      Previewing <strong>{{ previewLabel }}</strong> — your login and APIs are
      unchanged. Member breakdown and personal budget follow this person on
      Dashboard and Koneko A.
    </p>
    <p
      v-else-if="compact && viewAsActive"
      class="caption amber--text text--lighten-3 mb-0 mt-1 px-1"
    >
      Preview: <strong>{{ previewLabel }}</strong>
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  buildViewAsSelectOptions,
  dashboardViewAsState,
  isKonekoViewAsAdmin,
  readStoredViewAsUsername,
  syncDashboardViewAsFromStoreGetter,
  viewAsPreviewLabel,
  writeStoredViewAsUsername,
} from "@/utils/dashboardViewAsSync";
import {resolveKonekoAPlanningUsernameKey} from "@/config/konekoAConfig";

export default {
  name: "ViewAsAdminSelect",
  props: {
    compact: {type: Boolean, default: false},
    /** Drawer uses dark field; Dashboard card uses light. */
    dark: {type: Boolean, default: false},
  },
  data() {
    return {
      selectedKey: "",
    };
  },
  computed: {
    ...mapGetters(["userProfileData", "isAuthenticated"]),
    canUse() {
      return isKonekoViewAsAdmin(this.userProfileData);
    },
    selectItems() {
      return buildViewAsSelectOptions();
    },
    viewAsActive() {
      return Boolean(dashboardViewAsState.viewingAsPlanningKeyNonSelf);
    },
    previewLabel() {
      return viewAsPreviewLabel(
        dashboardViewAsState.viewingAsPlanningKeyNonSelf
      );
    },
  },
  watch: {
    userProfileData: {
      handler() {
        this.hydrateFromStorage();
        this.syncGlobal();
      },
      deep: true,
    },
  },
  created() {
    this.hydrateFromStorage();
    this.syncGlobal();
  },
  mounted() {
    // Vue 2 tears down this.$watch automatically when the component is destroyed.
    this.$watch(
      () => dashboardViewAsState.viewingAsPlanningKeyNonSelf,
      (key) => {
        const next = key ? String(key) : "";
        if (this.selectedKey !== next) this.selectedKey = next;
      }
    );
  },
  methods: {
    hydrateFromStorage() {
      if (!this.canUse) {
        this.selectedKey = "";
        return;
      }
      const raw = readStoredViewAsUsername();
      const key = raw && resolveKonekoAPlanningUsernameKey(raw);
      this.selectedKey = key || "";
    },
    syncGlobal() {
      syncDashboardViewAsFromStoreGetter(
        this.userProfileData,
        this.isAuthenticated
      );
    },
    onSelectChange(val) {
      const key = val ? String(val).trim() : "";
      writeStoredViewAsUsername(key);
      this.syncGlobal();
      this.$emit("change", dashboardViewAsState.viewingAsPlanningKeyNonSelf);
    },
  },
};
</script>

<style scoped>
.view-as-admin-select.compact {
  padding: 8px 12px 4px;
}

.view-as-select--compact {
  font-size: 13px;
}

.view-as-select >>> .v-input__slot {
  min-height: 36px !important;
}
</style>
